import { c as _c } from "react/compiler-runtime";
import { Button } from '@systemeio/components';
import { PlusIcon, ShoppingCartAddIcon, Trash02Icon } from '@systemeio/icons';
import { CurrencyEnum, PaymentMethodEnum } from '@systemeio/types';
import { OfferProduct } from 'modules/funnels/funnel/components/offer-settings/offer-product';
import { useOrderBumpAvailability } from 'modules/funnels/funnel/components/step-configuration-tab/offer-bump/hooks/use-order-bump-availability';
import { OfferConfigurationCard } from 'modules/funnels/funnel/components/step-configuration-tab/offer-configuration-card';
import { OfferFormEditType, OfferFormViewInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/offer-form-interface';
import React, { useState } from 'react';
import { Tooltip } from 'shared/components';
import Confirmation from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useMediaQuery from 'shared/hooks/use-media-query';
interface OfferBumpProps {
  currency: CurrencyEnum;
  offerBumps: OfferFormViewInterface['offer']['bumps'];
  onSaveBump: (bumps: OfferFormEditType['bumps']) => Promise<void>;
  paymentMethods: PaymentMethodEnum[];
}
function OfferBump(t0) {
  const $ = _c(55);
  const {
    offerBumps,
    onSaveBump,
    currency,
    paymentMethods
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    isDesktop
  } = useMediaQuery();
  const [isRemoveConfirmationOpen, setIsRemoveConfirmationOpen] = useState(false);
  const [isDraftOpen, setIsDraftOpen] = useState(false);
  const {
    canAddBump,
    disabledReason,
    mutateFunnelStepData
  } = useOrderBumpAvailability(paymentMethods);
  const savedBump = offerBumps.length ? offerBumps[0] : undefined;
  let t1;
  if ($[0] !== mutateFunnelStepData || $[1] !== onSaveBump) {
    t1 = async bumps => {
      await onSaveBump(bumps);
      if (bumps.length === 0) {
        setIsDraftOpen(false);
      }
      await mutateFunnelStepData();
    };
    $[0] = mutateFunnelStepData;
    $[1] = onSaveBump;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const saveBump = t1;
  let t2;
  if ($[3] !== savedBump) {
    t2 = () => {
      if (!savedBump) {
        setIsDraftOpen(false);
        return;
      }
      setIsRemoveConfirmationOpen(true);
    };
    $[3] = savedBump;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleRemoveClick = t2;
  if (!savedBump && !isDraftOpen) {
    const t3 = !disabledReason;
    const t4 = disabledReason ?? "";
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = () => setIsDraftOpen(true);
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    const t6 = !canAddBump;
    const t7 = isDesktop ? "sm" : "md";
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <PlusIcon />;
      $[6] = t8;
    } else {
      t8 = $[6];
    }
    let t9;
    if ($[7] !== t) {
      t9 = t("dashboard.funnel.configuration.offer.order_bump_add");
      $[7] = t;
      $[8] = t9;
    } else {
      t9 = $[8];
    }
    let t10;
    if ($[9] !== t6 || $[10] !== t7 || $[11] !== t9) {
      t10 = <Button type="button" onClick={t5} disabled={t6} variant="primary" size={t7}>{t8}{t9}</Button>;
      $[9] = t6;
      $[10] = t7;
      $[11] = t9;
      $[12] = t10;
    } else {
      t10 = $[12];
    }
    let t11;
    if ($[13] !== t10 || $[14] !== t3 || $[15] !== t4) {
      t11 = <div className="flex justify-center"><Tooltip disabled={t3} label={t4}>{t10}</Tooltip></div>;
      $[13] = t10;
      $[14] = t3;
      $[15] = t4;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    return t11;
  }
  let t3;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ShoppingCartAddIcon />;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== t) {
    t4 = t("dashboard.funnel.configuration.offer.order_bump");
    $[18] = t;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== t) {
    t5 = t("dashboard.funnel.configuration.offer.order_bump_description");
    $[20] = t;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== t) {
    t6 = t("global.delete");
    $[22] = t;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Trash02Icon />;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== handleRemoveClick || $[26] !== t6) {
    t8 = <Button aria-label={t6} onClick={handleRemoveClick} variant="secondary" size="icon-md">{t7}</Button>;
    $[25] = handleRemoveClick;
    $[26] = t6;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  const t9 = savedBump?.product ?? null;
  let t10;
  let t11;
  if ($[28] !== saveBump) {
    t10 = data => saveBump(data === null ? [] : [{
      product: data,
      digitalProduct: null
    }]);
    t11 = data_0 => saveBump(data_0 === null ? [] : [{
      product: null,
      digitalProduct: data_0
    }]);
    $[28] = saveBump;
    $[29] = t10;
    $[30] = t11;
  } else {
    t10 = $[29];
    t11 = $[30];
  }
  const t12 = savedBump?.digitalProduct ?? null;
  let t13;
  if ($[31] !== currency || $[32] !== paymentMethods || $[33] !== t10 || $[34] !== t11 || $[35] !== t12 || $[36] !== t9) {
    t13 = <div className="mt-5 flex flex-col gap-5"><OfferProduct product={t9} onSavePhysical={t10} onSaveDigital={t11} currency={currency} paymentMethods={paymentMethods} digitalProduct={t12} isBump={true} /></div>;
    $[31] = currency;
    $[32] = paymentMethods;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
    $[36] = t9;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== t13 || $[39] !== t4 || $[40] !== t5 || $[41] !== t8) {
    t14 = <OfferConfigurationCard icon={t3} title={t4} description={t5} action={t8}>{t13}</OfferConfigurationCard>;
    $[38] = t13;
    $[39] = t4;
    $[40] = t5;
    $[41] = t8;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setIsRemoveConfirmationOpen(false);
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== saveBump) {
    t16 = () => saveBump([]);
    $[44] = saveBump;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== t) {
    t17 = t("dashboard.funnel.configuration.offer.order_bump_confirmation");
    $[46] = t;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== isRemoveConfirmationOpen || $[49] !== t16 || $[50] !== t17) {
    t18 = <Confirmation status="error" opened={isRemoveConfirmationOpen} onClose={t15} onConfirm={t16} confirmationText={t17} />;
    $[48] = isRemoveConfirmationOpen;
    $[49] = t16;
    $[50] = t17;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  let t19;
  if ($[52] !== t14 || $[53] !== t18) {
    t19 = <>{t14}{t18}</>;
    $[52] = t14;
    $[53] = t18;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  return t19;
}
export default OfferBump;